import { generateRootObjectSchema, generateStringSchema, generateTranslationSchema, generateUrlSchema, generateBooleanSchema } from "components/cards/common/schema";
import { BaseParticleSpec, GetParticlePropsType, GetParticleSchemaType, generateParticleContainerSchema } from "components/cards/particles";

export const WebEmbedParticleSpec = new BaseParticleSpec("Web Embed", generateRootObjectSchema({
  container: generateParticleContainerSchema(),
  name: generateStringSchema("Name", "The name of the embedded web page."),
  source: generateUrlSchema("Source URL", "The source URL of the embedded web page."),
  translations: generateTranslationSchema("Web Embed", {
    source: generateUrlSchema("Source URL", "The source URL of the embedded web page."),
  }),
  noDefaultStyling: generateBooleanSchema("No Default Styling", "Remove default styling.", { defaultValue: false }),
  noAutoHeight: generateBooleanSchema("No Auto Height", "Disable auto height.", { defaultValue: false }),
  passThroughQueryParams: generateBooleanSchema("Pass Through Query Params", "Pass through query parameters from the current URL to the embedded URL.", { defaultValue: false }),
}));

export const specification = WebEmbedParticleSpec;

export type WebEmbedParticleSchema = GetParticleSchemaType<typeof WebEmbedParticleSpec>;

export type WebEmbedParticleProps = GetParticlePropsType<typeof WebEmbedParticleSpec>;
